/**
 * rm #2622
 * Реализация автозамены текста - данных о типах доставом и их стоимости.
 */

console.log('delivery_replace_text.js - connected');

window.$a_jQuery(function($) {
    // apiGetDataDeliveryFull();

    window.dataDeliveryReplaceText = function(data){
        console.log('dataDeliveryReplaceText: ', data);

        for (var option_id in data) {
            var option_data = data[option_id];
            for (var day_of_week in option_data) {
                var replace_data = option_data[day_of_week];
                var replace_str = '@' + option_id + '.';
                switch (day_of_week) {
                    case 'active':
                        continue;
                    case '6':
                        replace_str += 'saturday.';
                        break;
                    case '0':
                        replace_str += 'sunday.';
                        break;
                    default:
                        replace_str += 'weekdays.';
                        break;
                }

                if ($('.content_delivery_replace_text').length && typeof attilus_config.formatMoney !== 'undefined') {
                    $('.content_delivery_replace_text').html(
                        $('.content_delivery_replace_text').html()
                            .replace(new RegExp(replace_str + 'threshold', "g"),
                              attilus_config.formatMoney(replace_data.free_delivery_threshold))
                            .replace(new RegExp(replace_str + 'price', "g"),
                              attilus_config.formatMoney(replace_data.price))
                            .replace(new RegExp(replace_str + 'name', "g"),
                              replace_data.item_name)
                            .replace(new RegExp(replace_str + 'cutoff_time', "g"),
                            replace_data.cutoff_time)
                            .replace(new RegExp(replace_str + 'guaranteed_time', "g"),
                            replace_data.guaranteed_time)
                    );
                }
            }
        }
    };
});